<template>
  <redirect ref="redirect" :immediately="true" />
</template>

<script>
export default {
  async created() {
    // 環境によっては無限にリダイレクトする恐れがあるため、ローカルストレージを削除しておく。
    localStorage.removeItem(this.$appConfig.localStorageKeys.serviceID)
    localStorage.removeItem(this.$appConfig.localStorageKeys.locationHistory)
  },
}
</script>

<style lang="scss" scoped></style>
